"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultClassifierValueProviders = useDefaultClassifierValueProviders;
const useCountyValueProvider_1 = require("./useCountyValueProvider");
const useEthnicityValueProvider_1 = require("./useEthnicityValueProvider");
const useGenderValueProvider_1 = require("./useGenderValueProvider");
const useRegionValueProvider_1 = require("./useRegionValueProvider");
const useRegisterStateValueProvider_1 = require("./useRegisterStateValueProvider");
const useStateAndTerritoryValueProvider_1 = require("./useStateAndTerritoryValueProvider");
const useStateValueProvider_1 = require("./useStateValueProvider");
const useTerritoryValueProvider_1 = require("./useTerritoryValueProvider");
function useDefaultClassifierValueProviders() {
    return [
        (0, useCountyValueProvider_1.useCountyValueProvider)(),
        (0, useEthnicityValueProvider_1.useEthnicityValueProvider)(),
        (0, useGenderValueProvider_1.useGenderValueProvider)(),
        (0, useRegionValueProvider_1.useRegionValueProvider)(),
        (0, useRegisterStateValueProvider_1.useRegisterStateValueProvider)(),
        (0, useStateAndTerritoryValueProvider_1.useStateAndTerritoryValueProvider)(),
        (0, useStateValueProvider_1.useStateValueProvider)(),
        (0, useTerritoryValueProvider_1.useTerritoryValueProvider)(),
    ];
}
